import moment from 'moment';
import { ACTIONS } from 'actions/student-alerts';

const initialState = {
  correctAttempt: null,
  attemptTime: null,
  activityTime: null,
  eventName: null,
  resolvedTime: null,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.RECORD_QUESTION_ATTEMPT:
    case ACTIONS.RECORD_STUDENT_ACTIVITY:
      return {
        ...state,
        ...payload,
      };
    case ACTIONS.RESOLVE_STUDENT_ALERTS:
      return {
        ...state,
        resolvedTime: Number(moment()),
      };
    default:
      return state;
  }
}
